import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <header className="about-header">
          <h1>🔒 Polityka prywatności</h1>
          <Link to="/" className="back-link">← Powrót do strony głównej</Link>
        </header>

        <div className="about-content">
          <section className="about-section">
            <h2>1. Administrator danych</h2>
            <p>
              Administratorem serwisu <strong>codzisiaj.com</strong> jest właściciel projektu codzisiaj.
              Kontakt: <a href="mailto:kontakt@codzisiaj.com">kontakt@codzisiaj.com</a>
            </p>
            <p><em>Ostatnia aktualizacja: 13 sierpnia 2026 r.</em></p>
          </section>

          <section className="about-section">
            <h2>2. Jakie dane zbieramy</h2>
            <ul>
              <li>
                <strong>Dane techniczne</strong> — adres IP, typ przeglądarki, system operacyjny,
                czas wizyty (przez Google Analytics)
              </li>
              <li>
                <strong>Dane z formularzy</strong> — informacje podane przy zgłaszaniu wydarzenia
                (nazwa, miasto, data, opis itd.)
              </li>
            </ul>
          </section>

          <section className="about-section">
            <h2>3. Google Analytics</h2>
            <p>
              Korzystamy z Google Analytics (Google LLC) do analizy ruchu na stronie.
              Google może przekazywać dane do USA na podstawie standardowych klauzul umownych.
            </p>
            <ul>
              <li>
                Polityka Google:{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  policies.google.com/privacy
                </a>
              </li>
              <li>
                Wyłączenie śledzenia:{' '}
                <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
                  Wtyczka opt-out Google Analytics
                </a>
              </li>
            </ul>
          </section>

          <section className="about-section">
            <h2>4. Podstawa prawna (RODO)</h2>
            <ul>
              <li>
                <strong>Uzasadniony interes</strong> (art. 6 ust. 1 lit. f) — działanie serwisu
                i analiza ruchu
              </li>
              <li>
                <strong>Realizacja usługi</strong> (art. 6 ust. 1 lit. b) — obsługa zgłoszeń wydarzeń
              </li>
            </ul>
          </section>

          <section className="about-section">
            <h2>5. Twoje prawa</h2>
            <p>
              W związku z przetwarzaniem Twoich danych osobowych przysługują Ci prawa wynikające z RODO, w szczególności:
            </p>
            <ul>
              <li>prawo dostępu do swoich danych,</li>
              <li>prawo do sprostowania danych,</li>
              <li>prawo do usunięcia danych, w przypadkach przewidzianych w RODO,</li>
              <li>prawo do ograniczenia przetwarzania,</li>
              <li>prawo do przenoszenia danych, jeżeli ma ono zastosowanie,</li>
              <li>
                prawo do wniesienia sprzeciwu wobec przetwarzania danych opartego na uzasadnionym interesie
                administratora,
              </li>
              <li>prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.</li>
            </ul>
            <p>
              Aby skorzystać z przysługujących Ci praw lub uzyskać informacje dotyczące przetwarzania Twoich danych,
              skontaktuj się z nami pod adresem:{' '}
              <a href="mailto:kontakt@codzisiaj.com">kontakt@codzisiaj.com</a>.
            </p>
          </section>

          <section className="about-section">
            <h2>6. Bezpieczeństwo danych</h2>
            <p>
              Stosujemy odpowiednie środki techniczne i organizacyjne mające na celu ochronę danych osobowych przed
              nieuprawnionym dostępem, utratą, zmianą lub zniszczeniem.
            </p>
            <p>
              Połączenie z serwisem jest zabezpieczone przy użyciu protokołu HTTPS. Dostęp do danych i panelu
              administracyjnego jest ograniczony i zabezpieczony odpowiednimi mechanizmami uwierzytelniania.
              Dane są przechowywane z wykorzystaniem usług infrastruktury, z których korzysta serwis.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
